import React from "react";
import Header from "../components/Header";
import Months from "../components/Months";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div>
      <Header />
      <Months />
      <Footer />
    </div>
  );
}
